// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__wIvCe","input":"Checkbox_input__C5nrf","labelWrapper":"Checkbox_labelWrapper__NH7QC"};